/* global __webpack_public_path__:true */
/* eslint camelcase:off, no-unused-vars:off */
__webpack_public_path__ = `${'Edu' in window && window.Edu.isProduction && window.Edu.cdn || ''}/dist/`;
